import Logo from 'components/common/Logo';
import { Col, Container, Dropdown, Nav, Navbar, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import NotificationDropdownMenu from '../nav-items/NotificationDropdownMenu';
import ProfileDropdownMenu from '../nav-items/ProfileDropdownMenu';
import ThemeToggler from 'components/common/ThemeToggler';
import GlobalSearchBox from 'components/common/GlobalSearchBox';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import EcommerceNavbar from './EcommerceNavbar';
import { useLayoutEffect, useRef, useState } from 'react';

const EcommerceTopbar = () => {
  const { user } = useSelector((s: RootState) => s.auth);
  const { cart } = useSelector((s: RootState) => s.user.cart);
  const { wishlist } = useSelector((s: RootState) => s.user.wishlist);

  const wishlistItems = wishlist.length;
  const cartItems = cart.reduce((a, i) => a + (i.products.length || 0), 0);
  const [showProfile, setShowProfile] = useState(false);

  const barRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if (!barRef.current) return;
    const h = barRef.current.offsetHeight;
    document.documentElement.style.setProperty('--topbar-h', `${h}px`);
  }, []);

  return (
    <header
      ref={barRef}
      className="topbar-fixed position-sticky top-0 start-0 ecommerce-navbar"
      style={{
        zIndex: 1040,
        backgroundColor: '#f8f9fa',
        backdropFilter: 'blur(6px)'
      }}
    >
      <Container fluid="lg" className="px-4 py-4 rounded-bottom-2">
        <Navbar className="p-0">
          <Row className="gx-2 gy-2 px-2 align-items-center w-100 flex-wrap">
            <Col xs={6} md="auto">
              <Link to={'/'} className="text-decoration-none">
                <Logo width={130} />
              </Link>
            </Col>

            <Col
              xs={12}
              md={4}
              className="order-3 order-md-1 mt-2 mt-md-0 flex-grow-1 d-flex justify-content-center"
            >
              <GlobalSearchBox placeholder="Search products, brands, vendors..." />
            </Col>

            <Col xs={6} md="auto" className="ms-auto order-2 order-md-2">
              <Nav
                as="ul"
                className="navbar-nav-icons d-flex align-items-center justify-content-end"
              >
                <Nav.Item as="li" className="me-3">
                  <ThemeToggler />
                </Nav.Item>

                {user?.role === 'customer' && (
                  <>
                    <Nav.Item as="li">
                      <Nav.Link
                        as={Link}
                        to="/wishlist"
                        className="px-2 icon-indicator icon-indicator-primary me-3"
                      >
                        <FeatherIcon icon="heart" size={20} />
                        <span className="icon-indicator-number">
                          {wishlistItems}
                        </span>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item as="li">
                      <Nav.Link
                        as={Link}
                        to="/cart"
                        className="px-2 icon-indicator icon-indicator-primary me-3"
                      >
                        <FeatherIcon icon="shopping-cart" size={20} />
                        <span className="icon-indicator-number">
                          {cartItems}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                  </>
                )}

                {user && (
                  <Nav.Item as="li">
                    <Dropdown autoClose="outside">
                      <Dropdown.Toggle
                        as={Link}
                        to="#"
                        className="dropdown-caret-none nav-link icon-indicator icon-indicator-sm icon-indicator-danger me-3"
                        variant=""
                      >
                        <FeatherIcon icon="bell" size={20} />
                      </Dropdown.Toggle>
                      <NotificationDropdownMenu className="mt-2" />
                    </Dropdown>
                  </Nav.Item>
                )}

                <Nav.Item as="li" className="me-3">
                  <Dropdown
                    autoClose="outside"
                    onToggle={() => setShowProfile(!showProfile)}
                  >
                    <ProfileDropdownMenu
                      className="mt-2"
                      showProfile={showProfile}
                      setShowProfile={setShowProfile}
                    />
                  </Dropdown>
                </Nav.Item>
              </Nav>
            </Col>
          </Row>
        </Navbar>
      </Container>
      <div className="">
        <EcommerceNavbar />
      </div>
    </header>
  );
};

export default EcommerceTopbar;
